module.exports = __webpack_public_path__ + "static/osaka-2-1711acc156c41f46cb9209c561038da2.png";